<template>
    <div class="h-full grid grid-cols-2 gap-2 md:grid-cols-1">
        <slot></slot>
    </div>
</template>



